import { render } from "./bvg_emp.vue?vue&type=template&id=ae95af2e"
import script from "./bvg_emp.vue?vue&type=script&lang=js"
export * from "./bvg_emp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__